import { defaultApiState } from '../api.state';

export const collectionState = {
  apiState: {
    getCollections: defaultApiState,
    addCollection: defaultApiState,
    updateCollection: defaultApiState,
    getCollection: defaultApiState,
    deleteCollection: defaultApiState,
    updateSequence: defaultApiState,
  },
  collections: [],
  collection: undefined,
};
